import React from 'react'

const useVisualViewport = () => {
  // eslint-disable-next-line
  const [defaultViewportHeight, setDefaultViewportHeight] = React.useState(
    window.visualViewport.height
  )
  const [isKeyboardOn, setIsKeyboardOn] = React.useState(false)

  const viewportHandler = event => {
    const viewportHeight = event.target.height
    if (viewportHeight < defaultViewportHeight) {
      setIsKeyboardOn(true)
    } else {
      setIsKeyboardOn(false)
    }
  }

  React.useEffect(() => {
    window.visualViewport.addEventListener('resize', viewportHandler)
    return () => {
      window.visualViewport.removeEventListener('resize', viewportHandler)
    }
    // eslint-disable-next-line
  }, [])

  return { isKeyboardOn }
}

export default useVisualViewport
